import React from "react"
import { Typography, Grid } from "@mui/material"
import { Formik } from "formik"
import { useDispatch } from "react-redux"
import AppTextField from "components/StyledComponents/AppTextField"
import AppSelect from "components/StyledComponents/AppSelect"
import AppButton from "components/StyledComponents/AppButton"
import CommonModal from "components/CommonModal"
import { validationSchemaVipGroupField } from "helpers/validationSchema"
import { createVipGroupFieldAction, updateVipGroupFieldAction } from "redux/superAdmin/actions"

const FieldModal = ({ open, onClose, isEdit, fieldData, section }) => {
  const dispatch = useDispatch()
  const formikRef = React.useRef()

  React.useEffect(() => {
    if (open && formikRef.current) {
      formikRef.current.resetForm()
    }
  }, [open])

  const initialValues = {
    name: isEdit ? fieldData?.schema_field_label : "",
    type: isEdit ? fieldData?.schema_field_type : ""
  }

  const fieldTypes = [
    { label: "Text", value: "text" },
    { label: "Image", value: "image" },
    { label: "Date", value: "date" },
    { label: "Time", value: "time" },
    { label: "Number", value: "number" }
  ]

  const handleSubmit = (values) => {
    const schema_field_name = values.name.toLowerCase().replace(/\s+/g, "_")
    const schema_field_label = values.name
    const schema_field_type = values.type.toLowerCase()

    if (isEdit) {
      const payload = {
        schema_field_name,
        schema_field_label
      }
      dispatch(
        updateVipGroupFieldAction({
          id: fieldData.id,
          parentId: section,
          payload,
          onClose
        })
      )
    } else {
      const payload = {
        parent_field: section.id,
        schema_field_name,
        schema_field_label,
        schema_field_type
      }
      dispatch(createVipGroupFieldAction({ parentId: section, payload, onClose }))
    }
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchemaVipGroupField}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {(formik) => (
        <CommonModal open={open} onClose={onClose} maxWidth="sm" hideAction={true}>
          <Typography variant="h2" className="mb-4 text-center">
            {isEdit ? "Edit Field" : "Add Field"}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AppTextField
                name="name"
                label="Field Name"
                placeholder="Enter field name"
                value={formik.values.name}
                isUpperCase={true}
                isRequired={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <AppSelect
                name="type"
                label="Field Type"
                placeholder="Select field type"
                isUpperCase={true}
                isRequired={true}
                value={formik.values.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                menuItems={fieldTypes}
                error={formik.errors.type}
                touched={formik.touched.type}
              />
            </Grid>
            <Grid item xs={12} className="d-flex justify-content-center gap-3 mt-2">
              <AppButton onClick={onClose} variant="outlined" sx={{ height: 48, width: 150 }}>
                Cancel
              </AppButton>
              <AppButton onClick={formik.handleSubmit} sx={{ height: 48, width: 150 }}>
                {isEdit ? "Update" : "Save"}
              </AppButton>
            </Grid>
          </Grid>
        </CommonModal>
      )}
    </Formik>
  )
}

export default FieldModal
